import { Nav } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { isProline } from '../../../helpers'
import { useUserContext } from '../../../context/user/UserProvider'

interface IProLineBottomHeaderNavProps {
  handleClick: (e: any) => void
}

const ProLineBottomHeaderNav: React.FC<IProLineBottomHeaderNavProps> = ({
  handleClick,
}) => {
  const { isDarkMode } = useUserContext()

  // Probably a good idea to move this whole navbar stuff into the site_menus table later.

  return (
    <Nav>
      <Nav.Item>
        <Nav.Link
          as={Link}
          to={'/sl/l/New_Products_2025'}
          id={'/sl/l/New_Products_2025'}
          target={'_self'}
          className={`${isDarkMode ? 'text-light' : ''}`}
          onClick={handleClick}
        >
          New for 2025
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          as={Link}
          to={'/sl/l/Just_Arrived'}
          id={'/sl/l/Just_Arrived'}
          target={'_self'}
          className={`${isDarkMode ? 'text-light' : ''}`}
          onClick={handleClick}
        >
          Just Arrived
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          as={Link}
          to={'/sl/c/Comets'}
          id={'/sl/c/Comets'}
          target={'_self'}
          className={`${isDarkMode ? 'text-light' : ''}`}
          onClick={handleClick}
        >
          Comets
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          as={Link}
          to={'/sl/c/Mines'}
          id={'/sl/c/Mines'}
          target={'_self'}
          className={`${isDarkMode ? 'text-light' : ''}`}
          onClick={handleClick}
        >
          Mines
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          as={Link}
          to={'/sl/c/1000-gram-cakes'}
          id={'/sl/c/1000-gram-cakes'}
          target={'_self'}
          className={`${isDarkMode ? 'text-light' : ''}`}
          onClick={handleClick}
        >
          1000 Gram Multi Shots
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          as={Link}
          to={'/sl/c/Firing-Systems'}
          id={'/sl/c/Firing-Systems'}
          target={'_self'}
          className={`${isDarkMode ? 'text-light' : ''}`}
          onClick={handleClick}
        >
          Firing Supplies
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          as={Link}
          to={'/sl/c/Mortars--Racks'}
          id={'/sl/c/Mortars--Racks'}
          target={'_self'}
          className={`${isDarkMode ? 'text-light' : ''}`}
          onClick={handleClick}
        >
          Mortars & Racks
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          as={Link}
          to={'/sl/b/76_Pro_Line_Italia_Fireworks'}
          id={'/sl/b/76_Pro_Line_Italia_Fireworks'}
          target={'_self'}
          className={`${isDarkMode ? 'text-light' : ''}`}
          onClick={handleClick}
        >
          '76 Pro Line Italia
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          as={Link}
          to={'/sl/b/76_Show_Series'}
          id={'/sl/b/76_Show_Series'}
          target={'_self'}
          className={`${isDarkMode ? 'text-light' : ''}`}
          onClick={handleClick}
        >
          '76 Show Series
        </Nav.Link>
      </Nav.Item>
    </Nav>
  )
}

export default ProLineBottomHeaderNav
